export const TOGGLE_ROLE= "TOGGLE_ROLE";
export const TOGGLE_THEME="TOGGLE_THEME";
export const TOGGLE_AUTH= "TOGGLE_AUTH";
export const SET_TOKEN="SET_TOKEN";
export const SET_USER= "SET_USER";